import { Component, OnInit, inject } from '@angular/core';
import { LimitOffsetPaging, Sort } from '../../../core/models/paged-results/limit-offset-paging.model';
import { User } from '../../../core/models/user.model';
import { PagedUsers, UsersService } from '../../../core/services/users.service';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { UserSettings } from '../../../core/enums/user-settings.enum';
import { UserListFilters } from '../../../core/models/user-settings/user-management-settings.model';
import { UserSettingsService } from '../../../core/services/user-settings.service';
import { UserFiltersComponent } from '../../components/user-filters/user-filters.component';
import { PaginationHeaderComponent } from '../../../shared/components/pagination-header/pagination-header.component';
import { DatePipe } from '@angular/common';
import { SortableColumnComponent } from '../../../shared/components/sortable-column/sortable-column.component';
import { UserTypeComponent } from '../../../shared/components/user-type/user-type.component';
import { UserStatusComponent } from '../../../shared/components/user-status/user-status.component';
import { UserActionsComponent } from '../../components/user-actions/user-actions.component';
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-capture-admin-users',
    templateUrl: './capture-admin-users.component.html',
    styleUrls: ['./capture-admin-users.component.scss'],
    imports: [UserFiltersComponent,
              RouterLink,
              PaginationHeaderComponent,
              SortableColumnComponent,
              UserTypeComponent,
              UserStatusComponent,
              UserActionsComponent,
              PaginationComponent,
              MatProgressSpinner,
              DatePipe]
})
export class CaptureAdminUsersComponent implements OnInit {
  private usersService = inject(UsersService);
  private userSettingsService = inject(UserSettingsService);
  private route = inject(ActivatedRoute);

  filters: UserListFilters = new UserListFilters();
  sort: Sort;
  paging: LimitOffsetPaging;
  users: User[] = [];
  refreshing = false;

  ngOnInit() {
    this.init();
  }

  onPageSizeChange(size) {
    this.paging.pageSize = size;
    this.loadUsers();
  }

  onPageChange(page) {
    this.paging.currentPage = page;
    this.loadUsers();
  }

  onSortChange(sort: Sort) {
    this.sort = sort;
    this.loadUsers();
  }

  onFiltersChange(filters: UserListFilters) {
    this.filters = filters;
    this.saveFilters();
    this.loadUsers();
  }

  onUserChange(user: User) {
    const index = this.users.findIndex(u => u.id === user.id);
    if (index > -1) {
      this.users[index] = user;
    }
  }

  private init() {
    this.sort = Sort.fromQueryParams(this.route.snapshot.queryParams, { col: 'fullName', dir: 'asc' });
    this.paging = LimitOffsetPaging.fromQueryParams(this.route.snapshot.queryParams, { pageSize: 100 });
    this.loadFilters();
    this.loadUsers();
  }

  private loadUsers() {
    this.refreshing = true;

    const { currentPage, pageSize } = this.paging;

    this.usersService.getList(currentPage, pageSize, this.sort, this.filters).subscribe((pageUsers: PagedUsers) => {
      this.paging = pageUsers.meta.paging;
      this.users = pageUsers.users || [];
      this.refreshing = false;
    });
  }

  private loadFilters() {
    const filters = this.userSettingsService.get<UserListFilters>(UserSettings.captureAdminUserListFilters);

    if (filters) {
      this.filters = { ...filters };
    }
  }

  private saveFilters() {
    const newFilters = { ...this.filters };
    this.userSettingsService.save<UserListFilters>(UserSettings.captureAdminUserListFilters, newFilters);
  }
}
